<template>
  <div class="pagination-indicator-component">
    <div
      v-for="(n, idx) in total"
      :key="n"
      class="indicator"
      :class="{ active: idx === activeIndex }"
    />
  </div>
</template>

<script>
export default {
  props: {
    activeIndex: {
      type: Number,
    },
    total: {
      type: Number,
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination-indicator-component {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 16px;

  .indicator {
    background: black;
    border-radius: 100%;
    height: rem-calc(7);
    margin: 0 rem-calc(4);
    opacity: 0.3;
    padding: 0;
    width: rem-calc(7);

    &.active {
      opacity: 1.0;
    }
  }
}
</style>
